<script setup lang="ts">
import { formatNumber } from "@/services/Utils/DecimalFormatter";
import { declaredUnitCodeSymbol } from "@/utils/declaredUnitSymbol";

const props = defineProps<{
  amount: number | null;
  unit: string;
  constructionUnit: string;
  percentage?: number;
}>();
</script>

<template>
  <div
    v-if="props.amount !== null && props.percentage !== null"
    class="shrink-0">
    <!-- A step up from t-caption-bold over muted t-xs: this pair is what tells you whether an entry is
         sane, and it was the smallest text in the dialog (RTLCA-5192). -->
    <div class="t-small-bold flex gap-4">
      <p>
        {{ formatNumber(props.amount ?? 0) }}
        {{ declaredUnitCodeSymbol(props.unit) }}
        pr. 1
        {{ declaredUnitCodeSymbol(props.constructionUnit) }}
      </p>
    </div>
    <p class="text-type-default t-caption">{{ formatNumber(props.percentage ?? 0) }}%</p>
  </div>
</template>
